<template>
  <div>
    <div v-if="loading" class="text-center bg-gray-200 p-4 rounded">
      <Loader />
    </div>

    <div v-else-if="pipelines.length" class="list list-spaced rounded">
      <div class="flex py-2 font-medium text-sm bg-gray-200 uppercase text-gray-600">
        <div class="flex-1 px-4">Name</div>
      </div>

      <PipelineLine
        v-for="line in pipelines"
        :key="line.uuid"
        :pipeline="line"
        @pipeline-edit="editPipeline"
        @pipeline-delete="confirmDeletePipeline"
      />
    </div>

    <div v-else class="bg-gray-200 p-6 text-center rounded">No pipelines found.</div>

    <template v-if="$membershipHasPermissionTo('edit pipelines')">
      <portal v-if="pipeline && isActionEdit" to="app-dialog">
        <ModalEdit :pipeline="pipeline" @closed="resetAction" />
      </portal>
    </template>

    <template v-if="$membershipHasPermissionTo('edit projects')">
      <portal v-if="pipeline && isActionDelete" to="app-dialog">
        <BaseDialogDelete
          danger
          :custom-classes="'max-w-md'"
          @closed="resetAction"
          @confirmed="$emit('pipeline-delete', pipeline.id)"
        />
      </portal>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import ModalEdit from '@/components/Pipelines/ModalEdit.vue';
import PipelineLine from './PipelineLine.vue';

const ACTION_EDIT = 'edit';
const ACTION_DELETE = 'delete';

export default {
  components: {
    PipelineLine,
    ModalEdit,
  },

  props: {
    loading: Boolean,
    projectUuid: { type: String, required: true },
    pipelines: { type: Array, default: () => [] },
  },

  data: () => ({
    pending: false,
    action: null,
  }),

  computed: {
    ...mapGetters('ui/pipelines', ['pipeline']),

    isActionEdit() {
      return this.action === ACTION_EDIT;
    },

    isActionDelete() {
      return this.action === ACTION_DELETE;
    },
  },

  methods: {
    ...mapMutations('ui/pipelines', ['setCurrent']),

    editPipeline(pipeline) {
      this.setCurrent(pipeline.id);
      this.action = ACTION_EDIT;
    },

    confirmDeletePipeline(pipeline) {
      this.setCurrent(pipeline.id);
      this.action = ACTION_DELETE;
    },

    resetAction() {
      this.setCurrent(null);
      this.action = null;
    },
  },
};
</script>
